import { Card, Stack, Text, useComputedColorScheme } from '@mantine/core'

import { OutsideAnchor } from '#components/OutsideAnchor'

import styles from './SystemStatusCard.module.css'

export const SystemStatusCard = () => {
  const colorScheme = useComputedColorScheme('light')

  return (
    <Card classNames={styles} mih={180} miw={200} maw={400} flex="1" w="100%">
      <Stack gap={15} justify="space-between" h="100%">
        <Text fw="bold">System Status</Text>
        <iframe
          src={`https://status.scripto.live/badge?theme=${colorScheme}`}
          width="250"
          height="30"
          frameBorder="0"
          scrolling="no"
          style={{ colorScheme: 'normal' }}
          title="Scripto System Status"
        />
        <OutsideAnchor
          href="https://status.scripto.live/"
          tracking={{
            source: 'dashboard',
            to: 'system status',
          }}
        >
          Scripto Status
        </OutsideAnchor>
      </Stack>
    </Card>
  )
}
